import { AfterContentChecked, Component, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductService } from 'src/app/service/product.service';
import { Product } from 'src/app/types/types';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { getCart, saveCart } from '../localStorage/storage';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-show-product',
  templateUrl: './show-product.component.html',
  styleUrls: ['./show-product.component.css']
})
export class ShowProductComponent implements OnInit {

  product:Product;
  activeSize : string = "";
  form:FormGroup ;
  loading : boolean = true;
  constructor(
    private productService: ProductService,
    private activateRouter : ActivatedRoute,
    private fb: FormBuilder
    ) {
      let id;
      activateRouter.params.subscribe(data => id = data.id.toString());
      this.productService.getProduct(id).subscribe( res => {
        this.product = res;
        this.loading = false;
      });
      this.form = this.fb.group({
        amount: new FormControl(0,[Validators.required,Validators.min(1),Validators.max(5)]),
      })
    } 

  ngOnInit(): void {
  }

  get notValidAmount() {
    return this.form.get('amount').invalid && this.form.get('amount').touched;
  }

  activateSize(size:string) {
    this.activeSize = size;
  }

  get getPrice() {
    return this.product.price - this.product.price * (this.product.discount / 100)
  }

  postSale() {
    if(this.form.valid && this.activeSize){
      saveCart(getCart().concat({ product:this.product, amount: this.form.value.amount, size:this.activeSize}))
      Swal.fire(
        'Agregado!',
        `Se ha agregado ${this.product.name} al carrito.`,
        'success'
      )
    }
  }

}
